import { AbstractControl } from '@angular/forms';
export class PasswordValidation {
    static ValidateUrl(controls: AbstractControl) {
    // console.log("isworking")
    console.log(controls.get('password')?.value)
    console.log(controls.get('confirmPassword')?.value)
    if (controls.get('password')?.value != controls.get('confirmPassword')?.value) {
        controls.get('confirmPassword')?.setErrors( {ValidateUrl: true} )
        console.log(controls.get('confirmPassword')?.setErrors)
    }
    else{
        return null;
    } 
}

}